<template>
  <div class="sidebar">
    <ul>
      <li v-for="el in this.data"><a :href="`#${toSlug(el.name)}`">{{el.name}}</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  props: ['data'],
  mounted(){
    console.log(this.data)
  },
  methods:{
    toSlug(string){
      return string.replaceAll(' ', '-');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.sidebar {
  width: 100%;
  height: 100%;
  max-width: 300px;
  position: fixed;
  // top: 0;
  display: flex;
  flex-direction: column;
  padding: 3rem;
  background: #F3F3F3;

  @media(max-width:600px){
    display: none;
  }

  ul {
    margin: 0;
    padding: 0;
  }

  li {
    width: 100%;
  }

  a {
    width: calc(100%);
    display: inline-block;
    font-size: 1.5rem;
    padding: 1.5rem 0;
    color: #2f2f2f;
    text-decoration: none;

    &:hover {
      color: #EFA190;
    }

  }

}
</style>
